
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmAcknowledgedOutlined as ObiAlarmAcknowledgedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-acknowledged-outlined.js';
 
 
 

 
 export const ObiAlarmAcknowledgedOutlined = createComponent({
   react: React,
   tagName: 'obi-alarm-acknowledged-outlined',
   elementClass: ObiAlarmAcknowledgedOutlinedElement,
   events: {
     
   }
  });
 
 